
jQuery(document).ready(function($) {

    $('.home-slider-wrap .home-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        autoplay: true,
        speed: 500, // Adjust speed for smoother transition
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false, // Disable opacity fade effect
        cssEase: 'ease-in-out', // Use a smooth easing function
        swipe: true, // Enable swipe gestures
        draggable: true, // Allow dragging
        touchThreshold: 10 // Adjust touch sensitivity
    });
  

        $('.features .feature-list').slick({
            slidesToShow: 5, // Number of features to show at once 
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                    }
                }
            ]
        });


        $('.landscape-tab-products-wrap .tab-content .products').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                    }
                }
            ]
        });

        function featuredSlickProducts(){

            $('.featured-categories-wrap .tab-content .products').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 5,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                        }
                    }
                ]
            });
        }

        featuredSlickProducts();

        $('.featured-categories-tabs .tab-item').on('click', function() {
            var categoryId = $(this).data('category-id');
            
            // Mark the clicked tab as active
            $('.featured-categories-tabs .tab-item').removeClass('active');
            $(this).addClass('active loading');
            
            // Perform AJAX request to load products by category
            $.ajax({
                url: ajaxurl, // Use the WordPress AJAX handler
                method: 'GET',
                data: {
                    action: 'load_category_products', // Action hook
                    category_id: categoryId,         // Category ID
                    posts_per_page: 12               // Limit to 12 products
                },
                beforeSend: function() {
                    
                },
                success: function(response) {
                    $('.featured-categories-tabs .tab-item').removeClass('loading');

                    $('.featured-categories-wrap .tab-content').html(response);
                    
                    // Initialize Slick Slider on new content
                    featuredSlickProducts();
                }
            });
        });


        if($('.single-product  ul.products ').length) {
            $('.single-product  ul.products ').slick({
                slidesToShow: 5,  // Number of products to show at once
                slidesToScroll: 1,
                arrows: true,     // Show next/prev arrows
                dots: true,      // Show pagination dots (optional)
                infinite: true,   // Infinite scroll
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }

        function startSlickProductGrid(){
            var $products = $('.grid-products-wrap .tab-content .products');
            
            if (!$products.length) return;
        
            // Destroy existing Slick instance if already initialized
            if ($products.hasClass('slick-initialized')) {
                $products.slick('unslick');
            }
        
            // Initialize Slick again
            $products.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true,
                responsive: [
                    { breakpoint: 1400, settings: { slidesToShow: 5, arrows: true } },
                    { breakpoint: 1024, settings: { slidesToShow: 4, arrows: true } },
                    { breakpoint: 768, settings: { slidesToShow: 3, arrows: true } },
                    { breakpoint: 480, settings: { slidesToShow: 2, arrows: true } }
                ]
            });
        }
        

        startSlickProductGrid();


        $('.grid-products-wrap .tab-products-header .tab-item').on('click', function() {
            var categoryId = $(this).data('category-id');
            
            // Mark the clicked tab as active
            $('.grid-products-wrap .tab-products-header .tab-item').removeClass('active');
            $(this).addClass('active loading');
            
            // Perform AJAX request to load products by category
            $.ajax({
                url: ajaxurl, // Use the WordPress AJAX handler
                method: 'GET',
                data: {
                    action: 'load_category_products', // Action hook
                    category_id: categoryId,         // Category ID
                    posts_per_page: 12               // Limit to 12 products
                },
                beforeSend: function() {
                    
                },
                success: function(response) {
                    $('.grid-products-wrap .tab-products-header .tab-item').removeClass('loading');
                    
                  //  $('.grid-products-wrap .tab-products-header .tab-content').html(response);

                    var $productsContainer = $('.grid-products-wrap .tab-content');

                    // Remove old Slick instance if exists
                    var $products = $productsContainer.find('.products');
                    if ($products.hasClass('slick-initialized')) {
                        $products.slick('unslick'); // Destroy Slick before replacing HTML
                    }

                    // Clear old content before inserting new HTML
                    $productsContainer.empty().html(response);
                    
                    // Initialize Slick Slider on new content

                        startSlickProductGrid();

                }
            });
        });
    
});
